import React from 'react';

const MissionDetailCards = ({ mission, index, onRemove, onInputChange }) => {
    return (
        <div className="bg-white border border-gray-100 rounded-[20px] p-5 mb-4 relative">
            {/* Header with Title and Red Minus Button */}
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold text-gray-900">
                    Mission #{index + 1}
                </h3>
                <button
                    onClick={() => onRemove(mission.id)}
                    className="text-[#E53E3E]"
                >
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
                        <line x1="8" y1="12" x2="16" y2="12" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                </button>
            </div>

            {/* Form Fields matching Layout precisely */}
            <div className="space-y-3">
                {/* Mission ID */}
                <div className="space-y-1">
                    <label className="block text-xs font-normal text-gray-400">Mission ID <span className="text-red-500">*</span></label>
                    <input
                        type="number"
                        placeholder="Enter Mission ID"
                        value={mission.missionId}
                        onChange={(e) => onInputChange(mission.id, 'missionId', e.target.value)}
                        className="w-full bg-white border border-gray-200 rounded-lg py-2 px-3 text-sm text-gray-900 focus:outline-none focus:border-[#0084FF]"
                    />
                </div>

                {/* POI Visible & POI Not Visible - Side by Side */}
                <div className="grid grid-cols-2 gap-3">
                    <div className="space-y-1">
                        <label className="block text-xs font-normal text-gray-400">POI Visible <span className="text-red-500">*</span></label>
                        <input
                            type="number"
                            placeholder="0"
                            min="0"
                            value={mission.poiVisible}
                            onChange={(e) => onInputChange(mission.id, 'poiVisible', e.target.value)}
                            className="w-full bg-white border border-gray-200 rounded-lg py-2 px-3 text-sm text-gray-900 focus:outline-none focus:border-[#0084FF]"
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="block text-xs font-normal text-gray-400">POI Not Visible <span className="text-red-500">*</span></label>
                        <input
                            type="number"
                            placeholder="0"
                            min="0"
                            value={mission.poiNotVisible}
                            onChange={(e) => onInputChange(mission.id, 'poiNotVisible', e.target.value)}
                            className="w-full bg-white border border-gray-200 rounded-lg py-2 px-3 text-sm text-gray-900 focus:outline-none focus:border-[#0084FF]"
                        />
                    </div>
                </div>

                {/* POI Added */}
                <div className="space-y-1">
                    <label className="block text-xs font-normal text-gray-400">POI Added <span className="text-red-500">*</span></label>
                    <input
                        type="number"
                        placeholder="0"
                        min="0"
                        value={mission.poiAdded}
                        onChange={(e) => onInputChange(mission.id, 'poiAdded', e.target.value)}
                        className="w-full bg-white border border-gray-200 rounded-lg py-2 px-3 text-sm text-gray-900 focus:outline-none focus:border-[#0084FF]"
                    />
                </div>

                {/* Status Dropdown */}
                <div className="space-y-1">
                    <label className="block text-xs font-normal text-gray-400">Status *</label>
                    <div className="relative">
                        <select
                            value={mission.status}
                            onChange={(e) => onInputChange(mission.id, 'status', e.target.value)}
                            className="w-full bg-white border border-gray-200 rounded-lg py-2.5 px-3 pr-8 appearance-none text-sm text-gray-900 focus:outline-none"
                        >
                            <option value="In Progress">In Progress</option>
                            <option value="Completed">Completed</option>
                        </select>
                        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MissionDetailCards;